import React, { FC } from 'react';
import { Container, ContentLoader } from './styles';

const Loader: FC = () => {
  return (
    <Container>
      <ContentLoader viewBox="0 0 200 64">
        <rect x="12" y="9" rx="5" ry="5" width="43" height="11" />
        <rect x="12" y="40" rx="10" ry="10" width="93" height="20" />
        <circle cx="142" cy="50" r="8" />
        <rect x="155" y="41" rx="8" ry="8" width="38" height="17" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
